export default "<main>\n    <h1>Connexion réussie !</h1>\n</main>\n"